/**
 * The language vocabulary, both directions.
 *
 * `User.language` on the API stores the DISPLAY NAME ("English" / "German") — that is the Prisma
 * default, what the SendGrid template map is keyed by, and what the `?language=` param on invite
 * links carries. i18n codes ("en" / "de") are a client concern: they drive `i18n.changeLanguage`
 * and `localStorage.i18nextLng`.
 *
 * Decode API values through `languageToValue`; encode with `valueToLanguage` before sending one
 * back. Writing a raw code to the API breaks every server-side consumer that keys off the name.
 */
export const languageToValue = {
  English: 'en',
  German: 'de',
} as const;

export const valueToLanguage = {
  en: 'English',
  de: 'German',
} as const;

export type LanguageValue = (typeof languageToValue)[keyof typeof languageToValue];
export type CanonicalLanguage = (typeof valueToLanguage)[keyof typeof valueToLanguage];
